import client from './axiosConfig';

export const getProducts = (params) => {
    const config = {
        url: `/inventory/product/`,
        method: "GET",
        params
    }
    const response = client(config);
    return response;
}

export const createProduct = (data) => {
    const config = {
        url: `/inventory/product/`,
        method: "POST",
        data
    }
    const response = client(config);
    return response;
}

export const editProductById = (data, id) => {
    const config = {
        url: `/inventory/product/${id}/`,
        method: "PATCH",
        data
    }
    const response = client(config);
    return response;
}

export const getProductById = (id, warehouseId = null) => {
    const config = {
        url: `/inventory/product/${id}/`,
        method: "GET",
        params: warehouseId ? { warehouse_id: warehouseId } : {},
    }
    const response = client(config);
    return response;
}

export const deleteProductById = (id) => {
    const config = {
        url: `/inventory/product/${id}/`,
        method: "DELETE",
    }
    const response = client(config);
    return response;
}

export const getCategories = (params) => {
    const config = {
        url: `/inventory/category/`,
        method: "GET",
        params
    }
    const response = client(config);
    return response;
}

export const getAttributes = (params) => {
    const config = {
        url: `/inventory/attribute/`,
        method: "GET",
        params
    }
    const response = client(config);
    return response;
}

export const getAllUOM = (params) => {
    const config = {
        url: `/inventory/uom/`,
        method: "GET",
        params
    }
    const response = client(config);
    return response;
}

export const addCategories = (data) => {
    const config = {
        url: `/inventory/category/`,
        method: "POST",
        data
    }
    const response = client(config);
    return response;
}

export const deleteCategoryById = (id) => {
    const config = {
        url: `/inventory/category/${id}/`,
        method: "DELETE",
    }
    const response = client(config);
    return response;
}

export const addUOMs = (data) => {
    const config = {
        url: `/inventory/uom/`,
        method: "POST",
        data
    }
    const response = client(config);
    return response;
}

export const deleteUOMById = (id) => {
    const config = {
        url: `/inventory/uom/${id}/`,
        method: "DELETE",
    }
    const response = client(config);
    return response;
}

export const addAttributes = (data) => {
    const config = {
        url: `/inventory/attribute/`,
        method: "POST",
        data
    }
    const response = client(config);
    return response;
}

export const deleteAttributeById = (id) => {
    const config = {
        url: `/inventory/attribute/${id}/`,
        method: "DELETE",
    }
    const response = client(config);
    return response;
}

export const fetchMakes = (params) => {
    const config = {
        url: `/inventory/product/makes/`,
        method: "GET",
        params
    }
    const response = client(config);
    return response;
}

export const uploadProductExcel = (file) => {
    const formData = new FormData();
    formData.append("file", file);

    const config = {
        url: `/inventory/product-excel/`,
        method: "POST",
        data: formData,
    };

    return client(config);
};